import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MapItem, Progression } from 'app/shared/models/Progression/progression';
import { ProgressionService } from 'app/shared/services/progression/progression.service';
import { Observable, Observer } from 'rxjs';

export interface DialogData {
  newTrophy: MapItem;
  actionDialog: string;
}

const reader = new FileReader();
// @NgModule({
//   imports: [MatFormFieldModule, MatInputModule],
// })

@Component({
  selector: 'app-choice-trophy',
  templateUrl: './choice-trophy.component.html',
  styleUrls: ['./choice-trophy.component.scss']
})
export class ChoiceTrophyComponent implements OnInit {

  choiceForm: FormGroup;
  color: ThemePalette = 'primary';
  imageBase64: string | ArrayBuffer;
  myProgression: Progression[];

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private progressionService: ProgressionService,
    public dialogRef: MatDialogRef<ChoiceTrophyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.convertFile(true, this.data.newTrophy.imageUrl);
    this.imageBase64 = this.data.newTrophy.imageUrl ? this.data.newTrophy.imageUrl : this.data.newTrophy.imageToAdd;
    this.data.newTrophy.url = null;
    this.getMyprogression();
  }

  onSubmit(type: string): void {
    switch (type) {
      case 'Trophy':
        this.data.newTrophy.supportId = this.choiceForm.get('trophy').value[0];
        this.data.newTrophy.levelId = this.choiceForm.get('trophy').value[1];
        this.data.newTrophy.type = 'Trophy';
        break;
      case 'Image':
        this.choiceForm.get('imgFile').value ?
          (this.data.newTrophy.imageToAdd = this.imageBase64?.toString(), this.data.newTrophy.imageUrl = null) :
          (this.data.newTrophy.imageUrl = this.imageBase64?.toString(), this.data.newTrophy.imageToAdd = null);


        this.data.newTrophy.imageLink = this.choiceForm.get('link').value;
        this.data.newTrophy.type = 'Image';
        break;
      case 'Url':
        this.data.newTrophy.url = this.choiceForm.get('externLink').value;
        this.data.newTrophy.type = 'Url';
        break;
      default:
        break;
    }

  }

  convertFile(event, input): void {
    switch (typeof event) {
      case 'object':
        const file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = (res) => {
          this.imageBase64 = res.target.result;
          // this.data.newTrophy.imageUrl = this.imageBase64?.toString();

          this.choiceForm.get(`${input}`).setValue('');
        };
        break;
      case 'string':
        this.imageBase64 = event;
        this.choiceForm.get(`${input}`).setValue('');
        this.data.newTrophy.imageUrl = event;

        // this.getBase64ImageFromURL(event).subscribe( res)
        break;

      default:
        break;

    }

  }

  private getBase64ImageFromURL(url: string) {
    return new Observable((observer: Observer<string>) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  private getBase64Image(img: HTMLImageElement) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }

  resetForm(): void {
    this.imageBase64 = null;
    this.choiceForm.get('trophy').setValue('');
    this.choiceForm.get('imgFile').setValue('');
    this.choiceForm.get('imgLink').setValue('');
    this.choiceForm.get('externLink').setValue('');

    this.data.newTrophy.levelId = null;
    this.data.newTrophy.supportId = null;
    this.data.newTrophy.type = null;
    this.data.newTrophy.url = null;
    this.data.newTrophy.imageToAdd = null;
  }

  private getMyprogression(): void {
    this.progressionService.getProgressionLicence(false).subscribe(res => {
      this.myProgression = res?.progression;
    });
  }

  private initForm(): void {
    this.choiceForm = this.formBuilder.group({
      choice: [this.data.newTrophy.type, Validators.required],
      trophy: [''],
      imgFile: [''],
      imgLink: [''],
      link: [''],
      externLink: [this.data.newTrophy.url]
    });

    this.choiceForm.get('choice').setValue(this.data.newTrophy.type);
    this.choiceForm.get('trophy').setValue([this.data.newTrophy.supportId, this.data.newTrophy.levelId]);
    this.choiceForm.get('link').setValue(this.data.newTrophy.imageLink);
  }

}
